import { render } from "./CompleteEditTraining.vue?vue&type=template&id=babd24d8&scoped=true"
import script from "./CompleteEditTraining.vue?vue&type=script&lang=js"
export * from "./CompleteEditTraining.vue?vue&type=script&lang=js"

import "./CompleteEditTraining.vue?vue&type=style&index=0&id=babd24d8&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-babd24d8"]])

export default __exports__